import * as ois from './ois';

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// Merge
const replace = (template, components) => {
  let questionsFinal = JSON.parse(JSON.stringify(template.questions));
  for (let i = template.questions.length - 1; i >= 0; i--) {
    let question = template.questions[i];
    if (question.component) {
      let compQs = components[question.component];
      compQs = JSON.parse(JSON.stringify(compQs));

      // Make unique keys for component questions
      compQs = compQs.map((compQ) => {
        // Custom props
        if (question.custom && question.custom[compQ.key]) {
          compQ = Object.assign(compQ, question.custom[compQ.key]);
        }

        compQ.key = question.key + capitalizeFirstLetter(compQ.key);

        // Dependents
        if (compQ.dependents){
          let newDependents = {};
          Object.keys(compQ.dependents).forEach((dependent) => {
            let newDependentName = question.key + capitalizeFirstLetter(dependent);
            newDependents[newDependentName] = compQ.dependents[dependent];
          });
          compQ.dependents = newDependents;
        }

        // Errors
        if (compQ.tag === 'error'){
          compQ.fields.forEach(field => {
            field.key = question.key + capitalizeFirstLetter(field.key);
          });
        }
        return compQ;
      });

      const tLeft = questionsFinal.slice(0, i);
      const tRight = questionsFinal.slice(i + 1);
      questionsFinal = [...tLeft, ...compQs, ...tRight];
    }
  }

  template.questions = questionsFinal;
  template.injectors = template.injectors;
};

export const process = (template, components) => {
  if (components) replace(template, components);
  if (template.injectors) {
    template.injectors.forEach((injector) => {
       ois[injector.fn](template, ...injector.args);
    });
  }
  return template;
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
